import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FileStatusData {
    file_id?: any;
    uuid?: any;
    collection_name?: string;
    collection_description?: string;
    original_name?: string;
    file_url?: string;
    status?: string;
    [key: string]: any;
}

interface GetFileStatus {
    fileStatus: FileStatusData | null;
    uploadProgress: string | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: GetFileStatus = {
    fileStatus: null,
    uploadProgress: null,
    isLoading: false,
    error: null,
};

const getFileStatusSlice = createSlice({
    name: "getFileStatus",
    initialState,
    reducers: {
        getfilestatus: (state, action: PayloadAction<FileStatusData>) => {
            const payload = action.payload || {};
            state.fileStatus = {
                ...payload,
                file_id: payload.file_id ?? payload.uuid ?? payload.id ?? null,
            };
            state.isLoading = false;
            state.error = null;
        },
        setFileUploadProgress: (state, action: PayloadAction<string>) => {
            state.uploadProgress = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetgetfilestatus: () => {
            return initialState;
        },
    },
});

export const {
    getfilestatus,
    setFileUploadProgress,
    setloading,
    seterror,
    resetgetfilestatus,
} = getFileStatusSlice.actions;

export default getFileStatusSlice.reducer;
